import React from 'react';
import UserSelect from '../../../components/userSelectList';
import Flatpickr from 'react-flatpickr';
import 'flatpickr/dist/themes/material_blue.css';
import {
  FILTERABLE_EXPEDIENT_STATUSES,
  ALL_EXPEDIENT_TYPES,
  EXPEDIENT_TYPE_LABELS,
  expedientStatusLabel,
} from '@claimup/shared/constants/expedient';
import { isPartnerRole } from '@claimup/shared/constants/roles';
import PartnerClientSelect from '../../../components/partners/PartnerClientSelect';

const ExpedientsFilters = ({
  showFilter,
  selectedEstado,
  setSelectedEstado,
  showPhases = false,
  selectedPhase = '',
  setSelectedPhase,
  selectedUser,
  setSelectedUser,
  role,
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  team = null,
  selectedTeamMember = '',
  setSelectedTeamMember,
}) => {
  if (!showFilter) return null;

  return (
    <div className='bg-white shadow-sm rounded-lg border border-gray-200 p-6 mb-6'>
      <div className='space-y-6'>
        <div>
          <label htmlFor='estadoFilter' className='block text-sm font-medium text-gray-700 mb-2'>
            Estado
          </label>
          <select
            id='estadoFilter'
            className='block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-lg'
            value={selectedEstado}
            onChange={e => setSelectedEstado(e.target.value)}
          >
            <option value=''>Todos los estados</option>
            {/* De la lista compartida, no a mano: la copia escrita aquí se
                quedó sin `Cobro parcial judicial` y sin los estados legados,
                y esos expedientes no se podían encontrar filtrando. */}
            {FILTERABLE_EXPEDIENT_STATUSES.map(estado => (
              <option key={estado} value={estado}>
                {expedientStatusLabel(estado)}
              </option>
            ))}
          </select>
        </div>

        {/* La fase, igual que el estado. Solo donde hay AR: a una empresa de
            solo recobro todo le sale «Extrajudicial». */}
        {showPhases && (
          <div>
            <label htmlFor='faseFilter' className='block text-sm font-medium text-gray-700 mb-2'>
              Fase
            </label>
            <select
              id='faseFilter'
              className='block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-lg'
              value={selectedPhase}
              onChange={e => setSelectedPhase(e.target.value)}
            >
              <option value=''>Todas las fases</option>
              {ALL_EXPEDIENT_TYPES.map(type => (
                <option key={type} value={type}>
                  {EXPEDIENT_TYPE_LABELS[type] || type}
                </option>
              ))}
            </select>
          </div>
        )}

        <div>
          <label className='block text-sm font-medium text-gray-700 mb-2'>Rango de fechas</label>
          <div className='grid grid-cols-1 md:grid-cols-2 gap-4'>
            <div>
              <label htmlFor='startDate' className='sr-only'>
                Fecha inicio
              </label>
              <Flatpickr
                id='startDate'
                value={startDate}
                onChange={([date]) => setStartDate(date)}
                placeholder='Fecha inicio'
                className='block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-lg'
                dateFormat='d/m/Y'
                maxDate={endDate || undefined}
              />
            </div>
            <div>
              <label htmlFor='endDate' className='sr-only'>
                Fecha fin
              </label>
              <Flatpickr
                id='endDate'
                value={endDate}
                onChange={([date]) => setEndDate(date)}
                placeholder='Fecha fin'
                className='block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-lg'
                dateFormat='d/m/Y'
                minDate={startDate || undefined}
              />
            </div>
          </div>
        </div>

        {/* Quién lleva cada expediente, o los que no lleva nadie: así se ve si
            alguno se ha quedado sin persona (docs/asignar-equipo-en-bloque-plan.md). */}
        {team && (
          <div>
            <label htmlFor='teamMemberFilter' className='block text-sm font-medium text-gray-700 mb-2'>
              Operador o gestor
            </label>
            <select
              id='teamMemberFilter'
              className='block w-full pl-3 pr-10 py-2 text-base border-gray-300 focus:outline-none focus:ring-blue-500 focus:border-blue-500 sm:text-sm rounded-lg'
              value={selectedTeamMember}
              onChange={e => setSelectedTeamMember(e.target.value)}
            >
              <option value=''>Todos</option>
              <option value='none'>Sin asignar</option>
              {team.map(p => (
                <option key={p._id} value={p._id}>
                  {`${p.username || ''} ${p.userlastname || ''}`.trim() || p.usermail}
                </option>
              ))}
            </select>
          </div>
        )}

        {role === 'admin' && (
          <div>
            <label className='block text-sm font-medium text-gray-700 mb-2'>Cliente</label>
            <UserSelect selectedUser={selectedUser} onUserChange={user => setSelectedUser(user)} />
          </div>
        )}

        {/* El despacho filtra entre SUS clientes; la lista de todos los usuarios
            (`/users/list`) es solo de admin. */}
        {isPartnerRole(role) && (
          <div>
            <label htmlFor='partnerClientFilter' className='block text-sm font-medium text-gray-700 mb-2'>
              Cliente
            </label>
            <PartnerClientSelect selectedUser={selectedUser} onUserChange={user => setSelectedUser(user)} />
          </div>
        )}
      </div>
    </div>
  );
};

export default ExpedientsFilters;
